import type { AvatarConfig, RankedStanding } from '@shared/index'
import { api } from './http'

export type RatingMePayload = {
  standing: RankedStanding
  seasonStartedAt: string
}

export type LeaderboardEntry = RankedStanding & {
  username: string
  avatar: AvatarConfig
}

export type LeaderboardYou = {
  /** 1-based among placed duelists. Null while still in placement. */
  position: number | null
}

export type LeaderboardPayload = {
  entries: LeaderboardEntry[]
  total: number
  page: number
  pageSize: number
  seasonStartedAt: string | null
  smallPool?: boolean
  you?: LeaderboardYou
}

/**
 * Current season standing for the signed-in account.
 */
export function fetchMyRating(token: string): Promise<RatingMePayload> {
  return api<RatingMePayload>('/rating/me', { token })
}

/**
 * One page of ranked duelists this season.
 */
export function fetchLeaderboard(
  token: string,
  page = 1,
): Promise<LeaderboardPayload> {
  return api<LeaderboardPayload>(`/rating/leaderboard?page=${page}`, { token })
}
